import { DetailViewCard } from '../../Compounds/CardWithTitle/DetailViewCard';
import { DetailPanelContainer } from '../../Compounds/DetailPanel/DetailPanelContainer';
import { LabelValueField, EditFieldType } from '../../Compounds/DetailPanel/LabelValueField';
import { updatePayment, Payment } from '../../../store/Payment';
import { getFormattedDate } from '../../../utils/helpers';
import { hasDataOrHigherPermissions } from '../../../store/User';
import { DetailPanelParams } from '../../Compounds/DetailPanel/DetailPanel';
import { EntityType } from '../../../store/Search';

export interface PaymentDetailsParams {
  data: Payment;
}

export const infoSections = (data: Payment): DetailPanelParams[] => [
  {
    data,
    canEdit: hasDataOrHigherPermissions()
      ? [
          {
            field: 'amount',
            type: EditFieldType.CURRENCY
          },
          {
            field: 'date',
            type: EditFieldType.DATE
          },
          {
            field: 'recipientId',
            type: EditFieldType.SEARCHBOX,
            mapType: EntityType.PAYMENT_RECIPIENT
          }
        ]
      : [],
    fieldMap: {
      assetNumber: 'Asset',
      date: 'Date',
      commissionsStatus: 'Commissions Status',
      amount: 'Amount',
      supplierName: 'Supplier',
      recipientId: 'Recipient',
      salesAgentName: 'Sales Agent',
      customerName: 'Customer'
    },
    associationNameFields: {
      recipientId: 'recipientName'
    },
    order: [
      'assetNumber',
      'date',
      'commissionsStatus',
      'amount',
      'supplierName',
      'recipientId',
      'salesAgentName',
      '',
      'customerName'
    ],
    links: [
      {
        field: 'assetNumber',
        link: `/asset/${data.assetId}`,
        external: false
      },
      {
        field: 'customerName',
        link: `/customer/${data.customerId}`,
        external: false
      }
    ]
  }
];

export const PaymentDetails = ({ data }: PaymentDetailsParams) => {
  const saveAction = (update: Payment) => updatePayment(update, true);

  return (
    <div
      className="space-y-4"
      data-testid="payment-details-drawer">
      <DetailViewCard
        enableCollapse
        key="info-detail-card"
        title="Info">
        <div
          data-testid="info-detail-card"
          className="min-h-[15rem]">
          <DetailPanelContainer
            data={infoSections(data)}
            saveAction={(d) => saveAction(d as Payment)}
          />
        </div>
      </DetailViewCard>
      <DetailViewCard
        enableCollapse
        key="meta-detail-card"
        title="Meta">
        <div
          className="flex px-4 pt-4 w-full"
          data-testid="meta-detail-card">
          <LabelValueField
            label="Created At"
            value={getFormattedDate(data.createdAt, 'lll')}
            field="createdAt"
          />
          <LabelValueField
            label="Modified At"
            value={getFormattedDate(data.updatedAt, 'lll')}
            field="updatedAt"
          />
        </div>
        <div className="flex px-4 w-full">
          <LabelValueField
            label="Created By"
            value={`${data.createdBy?.firstName || ''} ${data.createdBy?.lastName || ''}`}
            field="createdBy.name"
          />
          <LabelValueField
            label="Modified By"
            value={`${data.modifiedBy?.firstName || ''} ${data.modifiedBy?.lastName || ''}`}
            field="modifiedBy.name"
          />
        </div>
        <div className="flex px-4 w-full">
          <LabelValueField
            label="ID"
            value={data.id || ''}
            field="id"
          />
        </div>
      </DetailViewCard>
    </div>
  );
};
